import type { TransactionsFetchResponse } from '@shared/transactions-types';
import { logger } from '@luna/logger';
import { request } from '@luna/api';

import type { TransactionsUrlArgs } from '../TransactionsApiService';
import { getTransactionsUrl } from '../TransactionsApiService';

const PAGE_SIZE = 15;

export function fetchMultipleTransactions({
    productId,
    searchState,
    sort,
    page = 0,
    pageSize = PAGE_SIZE,
    isWithSum,
    isWithSumWithRoundup,
    isWithCount,
    isWithBalance,
    isWithProducts,
}: TransactionsUrlArgs): Promise<TransactionsFetchResponse> {
    const url = getTransactionsUrl({
        productId,
        searchState,
        sort,
        page,
        pageSize,
        isWithSum,
        isWithSumWithRoundup,
        isWithCount,
        isWithBalance,
        isWithProducts,
    });
    return request<TransactionsFetchResponse>(url).catch((error) => {
        logger.error('Transactions :: Transaction loading failed', error);
        throw error;
    });
}
